module.exports = __webpack_public_path__ + "static/media/NET_Core_Logo.0e23f371.svg";